import { $api } from "../AxiosInstance";

export class CurrencyService {
  static async getCurrencies() {
    return await $api.get("/api/admin/currency/all");
  }

  static async getCurrencyById(id) {
    return await $api.get("/api/admin/currency", { params: { id } });
  }

  static async createCurrency(
    code,
    isCalculate,
    isMain,
    divideOnExchange,
    showOnFront,
    localeCodes
  ) {
    return await $api.put("/api/admin/currency", {
      code,
      isCalculate,
      isMain,
      divideOnExchange,
      showOnFront,
      localeCodes,
    });
  }

  static async saveCurrency(
    id,
    code,
    isCalculate,
    isMain,
    divideOnExchange,
    showOnFront,
    localeCodes
  ) {
    return await $api.post("/api/admin/currency", {
      id,
      code,
      isCalculate,
      isMain,
      divideOnExchange,
      showOnFront,
      localeCodes,
    });
  }

  static async deleteCurrency(id) {
    return await $api.delete("/api/admin/currency", { params: { id } });
  }

  static async updateCurrency() {
    return await $api.get("/api/admin/currency/update");
  }
}
